import { ProColumns } from '@ant-design/pro-components';
import { Col, Form, Modal, Row, Space, Table } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import { useState } from 'react';
// icons
import { ExclamationCircleOutlined } from '@ant-design/icons';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import CustomDatePicker from 'base/ui/components/Input/customDatePicker';
import CustomInputNumber from 'base/ui/components/Input/customInputNumber';
import CustomInputString from 'base/ui/components/Input/customInputString';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import { SYSTEM_TITLE } from 'utils/constants';

export type TableListItem = {
  key: number;
  stt: number;
  nhomSP: string;
  typeSP: string;
  maSP: string;
  SP: string;
  typeBH: string;
  timeRemindPrev: string;
  timeRemindThis: string;
  timeApply: string;
  timeExpire: string;
};

const tableListDataSource: TableListItem[] = [
  {
    key: 1,
    stt: 1,
    nhomSP: 'MALLOCA',
    typeSP: 'THIETBI',
    maSP: '6024932',
    SP: 'Tủ lạnh',
    typeBH: '12 tháng',
    timeRemindPrev: 'Trước 30 ngày',
    timeRemindThis: 'Trước 60 ngày',
    timeApply: '01/01/2023',
    timeExpire: '30/04/2023',
  },
  {
    key: 2,
    stt: 2,
    nhomSP: 'MALLOCA',
    typeSP: 'THIETBI',
    maSP: '6024932',
    SP: 'Lò vi sóng',
    typeBH: '12 tháng',
    timeRemindPrev: 'Trước 60 ngày',
    timeRemindThis: 'Trước 60 ngày',
    timeApply: '01/01/2023',
    timeExpire: '30/04/9999',
  },
  {
    key: 3,
    stt: 3,
    nhomSP: 'MALLOCA',
    typeSP: 'THIETBI',
    maSP: '6024932',
    SP: 'Bếp gas',
    typeBH: '12 tháng',
    timeRemindPrev: 'Trước 30 ngày',
    timeRemindThis: 'Trước 30 ngày',
    timeApply: '01/01/2023',
    timeExpire: '30/04/2023',
  },
  {
    key: 4,
    stt: 4,
    nhomSP: 'MALLOCA',
    typeSP: 'THIETBI',
    maSP: '6024932',
    SP: 'Máy rửa chén',
    typeBH: '12 tháng',
    timeRemindPrev: 'Trước 30 ngày',
    timeRemindThis: 'Trước 30 ngày',
    timeApply: '01/01/2023',
    timeExpire: '30/04/9999',
  },
];

const createSetUpTimeWarranty = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.setup-time') + ' - ' + SYSTEM_TITLE;

    const defaultColumn: ProColumns<TableListItem>[] = [
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        fixed: true,
        width: 50,
        align: 'center',
      },
      {
        title: t('search-form.group-product'),
        dataIndex: 'nhomSP',
        width: 100,
        fixed: true,
      },
      {
        title: t('search-form.product-type'),
        dataIndex: 'typeSP',
        width: 100,
      },
      {
        title: t('search-form.product-code'),
        dataIndex: 'maSP',
        width: 100,
      },
      {
        title: t('search-form.product-name'),
        dataIndex: 'SP',
        width: 100,
      },
      {
        title: t('search-form.warranty-type'),
        dataIndex: 'typeBH',
        width: 100,
      },
      {
        title: t('remind-calendar.remind-date-prev'),
        dataIndex: 'timeRemindPrev',
        align: 'center',
        width: 100,
      },
      {
        title: t('remind-calendar.remind-date-this'),
        dataIndex: 'timeRemindThis',
        align: 'center',
        width: 100,
      },
      {
        title: t('search-form.apply-date'),
        dataIndex: 'timeApply',
        align: 'center',
        width: 100,
      },
      {
        title: t('remind-calendar.time-expire'),
        dataIndex: 'timeExpire',
        align: 'center',
        width: 100,
      },
    ];
    const defaultColumnAdd = cloneDeep(defaultColumn);

    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [form] = Form.useForm();
    const [formModal] = Form.useForm();
    const [selectRows, setSelectRows] = useState<TableListItem[]>([]);
    // Custom default columns table with resizeable
    const [columns, setColumns] = useState<ProColumns<TableListItem>[]>(defaultColumn);
    const [columnsAdd, setColumnAdd] = useState<ProColumns<TableListItem>[]>(defaultColumnAdd);

    // modal confirm when click button 'aplly to rows select'
    const [modal, contextHolder] = Modal.useModal();
    // ======================================================== function =================================================================
    // show filter form
    const showDrawer = () => {
      setOpen(true);
    };
    // close filter form
    const onClose = () => {
      setOpen(false);
    }; // hidden modal (Add)
    const hideModal = () => {
      setOpenModal(false);
    };
    const handleAdd = () => {
      setOpenModal(true);
    };

    const handleSave = () => {
      const data = formModal.getFieldsValue();
      console.log(data.timeApply);

      let content = `Bạn có chắc chắn muốn thay đổi thời hạn nhắc bảo hành Trước ${data.thoiHan ? data.thoiHan : 0
        } ngày, bắt đầu từ ngày ${data.timeApply.format('DD/MM/YYYY')}
      đến ngày 30/12/9999 cho những sản phẩm được chọn?`;

      const instance = modal.confirm({
        title: 'Cảnh báo',
        icon: <ExclamationCircleOutlined />,
        content: content,
        footer: (
          <div className="flex gap-4 justify-end mt-4">
            <CustomButton
              onClick={() => {
                instance.destroy();
              }}
            >
              {t('btn.cancel')}
            </CustomButton>
            <CustomButton
              onClick={() => {
                instance.destroy();
              }}
              type="primary"
            >
              {t('btn.continue')}
            </CustomButton>
          </div>
        ),
      });
    };

    // Function handle resize columns
    const handleResize =
      (index: number) =>
        (e: any, { size }: any) => {
          // Set columns
          setColumns((prevColumns) => {
            const nextColumns = [...prevColumns];
            nextColumns[index] = {
              ...nextColumns[index],
              width: size.width,
            };
            return nextColumns;
          });
        };
    const handleResizeTableAdd =
      (index: number) =>
        (e: any, { size }: any) => {
          // Set columns
          setColumnAdd((prevColumns) => {
            const nextColumns = [...prevColumns];
            nextColumns[index] = {
              ...nextColumns[index],
              width: size.width,
            };
            return nextColumns;
          });
        };

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.setup-time'),
          },
        ]}
        extras={
          <>
            <CustomButton onClick={handleAdd} type="primary">
              {t('btn.setup-time-warranty')}
            </CustomButton>

            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<TableListItem>
            columns={columns}
            handleResize={handleResize}
            rowSelection={{
              selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
              onChange(selectedRowKeys, selectedRows, info) {
                setSelectRows(selectedRows);
              },
            }}
            size="small"
            dataSource={tableListDataSource}
            scroll={{ x: 1500, y: 500 }}
            search={false}
            pagination={{
              pageSize: 5,
            }}
            rowKey="key"
            tableAlertOptionRender={() => {
              return null;
            }}
            tableAlertRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => {
              return (
                <Space size={24}>
                  <span>
                    Đã chọn {selectedRowKeys.length} mục
                    <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                      Hủy lựa chọn
                    </a>
                  </span>
                </Space>
              );
            }}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox onClose={onClose} open={open}>
          <SearchForm form={form} initialValues={{ typeWarranty: '12' }}>
            {/* công ty */}
            <SearchItem label={t('search-form.company')} name={'congty'}>
              <CustomInputString />
            </SearchItem>
            {/* Nhóm sản phẩm */}
            <SearchItem label={t('search-form.group-product')} name={'groupProduct'}>
              <CustomInputString />
            </SearchItem>
            {/* thời gian áp dụng */}
            <SearchItem label={t('search-form.apply-date')} name={'timeApplyFrom'}>
              <CustomDatePicker />
            </SearchItem>
            <SearchItem label={t('search-form.to')} name={'timeApplyTo'}>
              <CustomDatePicker />
            </SearchItem>
            {/* phân loại sản phẩm */}
            <SearchItem label={t('search-form.product-type')} name={'typeProduct'}>
              <CustomInputString />
            </SearchItem>
            {/* mã sản phẩm  và thời gian nhắc bảo hànhtimeApplyFrom*/}
            <SearchItem label={t('search-form.product-code')} name={'maSP'}>
              <CustomInputString />
            </SearchItem>
            <SearchItem label={t('search-form.warranty-period')} name={'timeNhac'}>
              <CustomInputString />
            </SearchItem>
            {/* tên sản phẩm và loại bảo hành */}
            <SearchItem label={t('search-form.product-name')} name={'tenSP'}>
              <CustomInputString />
            </SearchItem>
            <SearchItem label={t('search-form.warranty-type')} name={'typeWarranty'}>
              <CustomSelect
                options={[
                  { label: '6 tháng', value: '6' },
                  { label: '12 tháng', value: '12' },
                ]}
              />
            </SearchItem>
            <div className="col-span-4 sticky bottom-[-24px] py-2 bg-white w-full">
              <CustomButton htmlType="submit" className="my-auto" type="primary">
                {t('btn.search')}
              </CustomButton>
            </div>
          </SearchForm>
        </SearchBox>

        {/* form modal */}
        <Modal
          width={1500}
          title={t('remind-calendar.modal-add-title')}
          open={openModal}
          onCancel={hideModal}
          footer={
            <div className="flex justify-end">
              <CustomButton onClick={handleSave} htmlType="submit" type="primary">
                {t('btn.save')}
              </CustomButton>
              {contextHolder}
            </div>
          }
        >
          <Form form={formModal}>
            <Row gutter={10}>
              <Col>
                <Form.Item name="thoiHan" label={t('remind-calendar.remind-date')}>
                  <CustomInputNumber className=" w-[200px]" max={31} addonAfter={t('search-form.date')} />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name="timeApply" label={t('search-form.apply-date')}>
                  <CustomDatePicker className="w-[300px]" />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item>
                  <CustomButton type="primary">{t('btn.apply')}</CustomButton>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <CustomProTable<TableListItem>
            columns={columnsAdd}
            handleResize={handleResizeTableAdd}
            size="small"
            dataSource={tableListDataSource}
            scroll={{ x: 1400, y: 500 }}
            search={false}
            pagination={{
              pageSize: 5,
            }}
            rowKey="key"
          />
        </Modal>
      </PageWrapper>
    );
  });
};

export default createSetUpTimeWarranty;
